import { render, staticRenderFns } from "./FilterBar.vue?vue&type=template&id=45c20521&scoped=true&"
import script from "./FilterBar.vue?vue&type=script&lang=js&"
export * from "./FilterBar.vue?vue&type=script&lang=js&"
import style0 from "./FilterBar.vue?vue&type=style&index=0&id=45c20521&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c20521",
  null
  
)

export default component.exports